import { API_URL } from "config";

export async function outlookRequest(path, { signal, method = "GET", body, binary = false } = {}) {
  const token = localStorage.getItem("authToken");
  if (!token) throw new Error("Please sign in again.");
  const response = await fetch(`${API_URL}/outlook-mail${path}`, {
    method, signal, credentials: "include", cache: "no-store",
    headers: { Authorization: `Bearer ${token}`, Accept: binary ? "application/octet-stream" : "application/json", ...(body ? { "Content-Type": "application/json" } : {}) },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  if (!response.ok) {
    const error = new Error(response.status === 401 ? "Please sign in again." : [403, 404].includes(response.status) ? "Your mailbox access has changed." : response.status === 503 ? "Outlook Mail is not activated or temporarily unavailable. Contact your administrator." : response.status === 409 ? "This email is waiting for its Outlook copy to sync. Attachments will be available after sync." : "Mail could not be loaded. Please try again.");
    error.status = response.status;
    throw error;
  }
  return binary ? response.blob() : response.json();
}
export const formatMailTime = (value) => {
  if (!value || Number.isNaN(new Date(value).getTime())) return "—";
  return `${new Intl.DateTimeFormat("en-IN", { dateStyle: "medium", timeStyle: "short", timeZone: "Asia/Kolkata" }).format(new Date(value))} IST`;
};
export const formatReplyTime = (seconds) => {
  if (seconds === null || seconds === undefined || !Number.isFinite(Number(seconds)) || Number(seconds) < 0) return null;
  const total = Math.floor(Number(seconds));
  if (total < 60) return `${total} sec`;
  const minutes = Math.floor(total / 60);
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hr${minutes % 60 ? ` ${minutes % 60} min` : ""}`;
  return `${Math.floor(hours / 24)} day${Math.floor(hours / 24) === 1 ? "" : "s"}${hours % 24 ? ` ${hours % 24} hr` : ""}`;
};
export const recipientText = (recipients) => (recipients || []).map((recipient) => typeof recipient === "string" ? recipient : recipient.name ? `${recipient.name} <${recipient.address}>` : recipient.address).filter(Boolean).join(", ");
export const sortMessages = (messages) => [...new Map(messages.map((message) => [String(message.id), message])).values()].sort((left, right) => new Date(left.event_at) - new Date(right.event_at) || Number(left.id) - Number(right.id));
